export default "__VITE_ASSET__3seFObzq__"